import React, { useState, useEffect } from "react";
import { apiServices } from "../../services/Api";
import CustomerCard from "../Dashboard/CustomerCard";

const RecentTrades = ({ advisorId }) => {
  const ContentStyle = {
    display: "flex",
    gap: "20px",
    flexDirection: "column",
    alignItems: "center",
    padding: "0 2rem",
  };

  const [cardData, setCardData] = useState([]);

  useEffect(() => {
    const fetchAdvisorCardData = async () => {
      try {
        const response = await apiServices.get("users/calls");
        const data = Array.isArray(response) ? response : [];
        setCardData(data);
        console.log("User calls data for advisor profile:", data);
      } catch (error) {
        console.error("Error fetching user calls:", error);
        setCardData([]);
      }
    };

    if (advisorId) {
      fetchAdvisorCardData();
    }
  }, [advisorId]);

  return (
    <div
      className="recent-trades-container"
      style={{ display: "flex", alignItems: "center", width: "100%" }}
    >
      <div style={ContentStyle}>
        {Array.isArray(cardData) && cardData.length > 0 ? (
          cardData
            .filter((call) => !advisorId || call.advisorId === advisorId)
            .slice()
            .sort(
              (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
            )
            .map((call) => (
              <CustomerCard
                key={call.id || call.callId}
                data={call}
                sourcePage="/advisor-profile"
                showViewBtn={false}
              />
            ))
        ) : (
          <p style={{ color: "#6B7280", fontSize: "14px" }}>
            No recent trades available.
          </p>
        )}
      </div>
    </div>
  );
};

export default RecentTrades;
